"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlogLinkedInShareButton = exports.BlogTwitterShareButton = exports.BlogFacebookShareButton = exports.BlogShareButtons = exports.BlogShareArticleTitle = exports.BlogFooterWrapper = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var react_share_1 = require("react-share");

exports.BlogFooterWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  justify-content: center;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-self: flex-start;\n  text-align: center;\n"], ["\n  justify-content: center;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-self: flex-start;\n  text-align: center;\n"])));
exports.BlogShareArticleTitle = styled_components_1.default.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  justify-content: center;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-self: flex-start;\n  font-size: 2rem;\n  text-align: center;\n\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"], ["\n  justify-content: center;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-self: flex-start;\n  font-size: 2rem;\n  text-align: center;\n\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"])));
exports.BlogShareButtons = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  justify-content: center;\n  text-align: center;\n"], ["\n  justify-content: center;\n  text-align: center;\n"])));
exports.BlogFacebookShareButton = styled_components_1.default(react_share_1.FacebookShareButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: 5px;\n"], ["\n  margin-left: 5px;\n"])));
exports.BlogTwitterShareButton = styled_components_1.default(react_share_1.TwitterShareButton)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-left: 5px;\n"], ["\n  margin-left: 5px;\n"])));
exports.BlogLinkedInShareButton = styled_components_1.default(react_share_1.LinkedinShareButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-left: 5px;\n"], ["\n  margin-left: 5px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;